// Penetrant Testing (PT) Types

export type PTObjectType = 'Component' | 'Weld' | 'Surface'
export type PTStatus = 'Accepted' | 'Not Accepted'
export type PTMaterialType = 'Stainless steel' | 'Aluminium'

export const PT_TEST_SITES = ['Bergen', 'Mongstad', 'Ågotnes'] as const
export type PTTestSite = (typeof PT_TEST_SITES)[number]
export const PT_DEFAULT_TEST_SITE: PTTestSite = 'Bergen'

export interface PTEquipmentSettings {
  cleaning: string
  cleaningProductFamily: string
  cleaningBatchNo: string
  preInspectionCleaning: string
  penetrant: string
  penetrantProductFamily: string
  penetrantBatchNo: string
  penetrantTime: string
  developer: string
  developerProductFamily: string
  developerBatchNo: string
  developerTime: string
}

export interface PTInspector {
  id: string
  first_name: string
  last_name: string
  certification_number?: string
  pt_level?: number
  user_id?: string
}

export interface PTCompany {
  id: string
  name: string
  report_code: string | null
}

export interface PTReportData {
  testDate: string
  testSite?: string
  reportNumber: string
  objects: string[]
  objectDescription: string
  issuedBy: string
  verifiedBy?: string
  status: PTStatus
  objectType: PTObjectType
  equipmentSettings: PTEquipmentSettings
  certificationNumber: string
  sequenceNumber: string
  extentOfExamination: string
  material: PTMaterialType
  comments?: string
  company?: string
  report_code?: string | null
  attachedImage?: string
}

export interface PTFormData {
  testDate: string
  testSite: string
  reportNumber: string
  objects: string[]
  objectDescription: string
  issuedBy: string
  verifiedBy?: string
  status: PTStatus
  objectType: PTObjectType
  equipmentSettings: PTEquipmentSettings
  extentOfExamination: string
  extentOfExaminationType: 'spec' | 'percentage'
  material: PTMaterialType
  comments?: string
  company?: string
  report_code?: string | null
  attachedImage?: string
}

export const DEFAULT_PT_EQUIPMENT: PTEquipmentSettings = {
  cleaning: 'MR85',
  cleaningProductFamily: 'Water- & solvent-removable',
  cleaningBatchNo: '107882',
  preInspectionCleaning: 'Water swabbed with cloth',
  penetrant: 'MR68NF',
  penetrantProductFamily: 'Colour contrast',
  penetrantBatchNo: '101204170423',
  penetrantTime: '60 minutes',
  developer: 'MR70',
  developerProductFamily: 'Solvent-based, non-aqueous',
  developerBatchNo: '492699',
  developerTime: '60 minutes',
}
